import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';
import { AppointmentDto, CreateAppointmentDto, UpdateAppointmentDto, AppointmentResponse } from '../types/Appointment';


const getAuthHeaders = (contentType = 'multipart/form-data') => ({
    'Content-Type': contentType,
    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
});

export const getAppointmentById = async (id: string): Promise<AppointmentDto | undefined> => {
    try {
        const response = await axios.get<AppointmentDto>(`${API_URL}/Appointment/get-app/${id}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
            },
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        return undefined;
    }
};

export const getAppointmentsByClientId = async (
    clientId: number
): Promise<AppointmentDto[] | undefined> => {
    try {
        const response = await axios.get<AppointmentDto[]>(
            `${API_URL}/Appointment/get-apps-by-client/${clientId}`,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        return undefined;
    }
};

export const getAppointmentsByRealtor = async (realtorId: number): Promise<AppointmentDto[] | undefined> => {
    try {
        const response = await axios.get<AppointmentDto[]>(`${API_URL}/Appointment/get-apps-by-realtor/${realtorId}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
            },
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        return undefined;
    }
};

export const getAppoinmentByUser = async (clientId : number, realtorId: number) => {
    try {
        const response = await axios.get<AppointmentDto[]>(`${API_URL}/Appointment/get-appoinments/${realtorId}/${clientId}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if(response.status === 200) {
            return response.data;
        }

    } catch (error) {
        handleAuthError(error);
        return null;
    }
}

export const createAppointment = async (
    appointmentData: CreateAppointmentDto
): Promise<AppointmentResponse<AppointmentDto>> => {
    try {
        const response = await axios.post<AppointmentDto>(
            `${API_URL}/Appointment/create-appoint`,
            appointmentData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error: any) {
        handleAuthError(error);
        let errorMessage = "Error al agendar la cita";
        if (axios.isAxiosError(error) && error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error instanceof Error) {
            errorMessage = error.message;
        }
        return {
            success: false,
            message: errorMessage,
        };
    }
};

export const updateAppointment = async (
    appointmentData: UpdateAppointmentDto
): Promise<AppointmentDto | undefined> => {
    try {
        const response = await axios.put<AppointmentDto>(
            `${API_URL}/Appointment/update-app`,
            appointmentData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        return undefined;
    }
};

export const deleteAppointment = async (appointmentId: number) => {
    try {
        const response = await axios.delete(`${API_URL}/Appointment/delete/${appointmentId}`,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        return false;
    }
};


const handleAuthError = (error: any) => {
    console.log(error);
};